import { NgModule } from '@angular/core';

// components
import { WmTransitionModule } from './transition/index';
import { WmAlertModule } from './alert/index';
import { WmIconModule } from './icon/index';
import { WmButtonModule } from './button/index';
import { WmSpinnerModule } from './spinner/index';
import { WmInputModule } from './input/index';
import { WmCheckboxModule } from './checkbox/index';
import { WmExpandableModule } from './expandable/index';
import { WmExpandableContainerModule } from './expandable-container/index';
import { WmCardModule } from './card/index';
import { WmRadioModule } from './radio/index';
import { WmSelectModule } from './select/index';
import { WmDropdownModule } from './dropdown/index';
import { WmAutocompleteModule } from './autocomplete/index';
import { WmButtonToggleModule } from './button-toggle/index';
import { WmButtonToggleContainerModule } from './button-toggle-container/index';
import { WmBadgeModule } from './badge/index';
import { WmBreadcrumbsModule } from './breadcrumbs/index';
import { WmCaptionModule } from './caption/index';
import { WmHeroModule } from './hero/index';
import { WmLinkCardContainerModule } from './link-card-container/index';
import { WmTagModule } from './tag/index';
import { WmMenuModule } from './menu/index';
import { WmMenuAltModule } from './menu-alt/index';
import { WmMediaCardModule } from './media-card/index';
import { WmModalModule } from './modal/index';
import { WmMultiselectModule } from './multiselect/index';
import { WmPointModule } from './point/index';
import { WmProgressbarModule } from './progressbar/index';
import { WmSliderModule } from './slider/index';
import { WmSidenavModule } from './sidenav/index';
import { WmDirectivesModule, WmPipesModule } from '../shared/index';
import { WmSnackbarModule } from './snackbar/index';
import { WmSortModule } from './sort/index';
import { WmStepperModule } from './stepper/index';
import { WmSwitchModule } from './switch/index';
import { WmTabModule } from './tab/index';
import { WmTextareaModule } from './textarea/index';
import { WmTooltipModule } from './tooltip/index';
import { WmTooltipAltModule } from './tooltip-alt/index';
import { WmTopnavModule } from './topnav/index';
import { WmDatatableModule } from './datatable/index';
import { WmDatepickerModule } from './datepicker/index';
import { WmDropdownAltModule } from './dropdown-alt/index';
import { WmMultiselectAltModule } from './multiselect-alt/index';

@NgModule({
	imports: [
		WmTransitionModule,
		WmAlertModule,
		WmIconModule,
		WmButtonModule,
		WmSpinnerModule,
		WmInputModule,
		WmCheckboxModule,
		WmExpandableModule,
		WmExpandableContainerModule,
		WmCardModule,
		WmRadioModule,
		WmSelectModule,
		WmDropdownModule,
		WmDropdownAltModule,
		WmAutocompleteModule,
		WmButtonToggleModule,
		WmButtonToggleContainerModule,
		WmBadgeModule,
		WmBreadcrumbsModule,
		WmCaptionModule,
		WmHeroModule,
		WmLinkCardContainerModule,
		WmTagModule,
		WmMenuModule,
		WmMenuAltModule,
		WmMediaCardModule,
		WmModalModule,
		WmMultiselectModule,
		WmPointModule,
		WmProgressbarModule,
		WmSliderModule,
		WmSidenavModule,
		WmDirectivesModule,
		WmSnackbarModule,
		WmSortModule,
		WmStepperModule,
		WmSwitchModule,
		WmTabModule,
		WmTextareaModule,
		WmTooltipModule,
		WmTooltipAltModule,
		WmTopnavModule,
		WmPipesModule,
		WmDatatableModule,
		WmDatepickerModule
	],
	exports: [
		WmTransitionModule,
		WmAlertModule,
		WmIconModule,
		WmButtonModule,
		WmSpinnerModule,
		WmInputModule,
		WmCheckboxModule,
		WmExpandableModule,
		WmExpandableContainerModule,
		WmCardModule,
		WmRadioModule,
		WmSelectModule,
		WmDropdownModule,
		WmDropdownAltModule,
		WmAutocompleteModule,
		WmButtonToggleModule,
		WmButtonToggleContainerModule,
		WmBadgeModule,
		WmBreadcrumbsModule,
		WmCaptionModule,
		WmHeroModule,
		WmLinkCardContainerModule,
		WmTagModule,
		WmMenuModule,
		WmMenuAltModule,
		WmMediaCardModule,
		WmModalModule,
		WmMultiselectModule,
		WmMultiselectAltModule,
		WmPointModule,
		WmProgressbarModule,
		WmSliderModule,
		WmSidenavModule,
		WmDirectivesModule,
		WmSnackbarModule,
		WmSortModule,
		WmStepperModule,
		WmSwitchModule,
		WmTabModule,
		WmTextareaModule,
		WmTooltipModule,
		WmTooltipAltModule,
		WmTopnavModule,
		WmPipesModule,
		WmDatatableModule,
		WmDatepickerModule
	]
})
export class WmLibModule {}
